import CryptoPunkImg from "../Assets/cryptoPunk.png";
import EthIcon from "../Assets/eth.svg";
import TeamMemberIcon from '../Assets/teamMembersIcon.svg'
import NotableFollowerImg from '../Assets/notablefollowerimg.png'
import Avatar from "../Assets/notablefollowerimg.png";

const Data = [
  {
    id: 1,
    MainImg: CryptoPunkImg,
    trending: true,
    Heading: "Crypto Punk",
    Rating: "568",
    text: "26 February 2022 - 10,000 unique collectible characters with proof of ownership stored on the Ethereum blockchain.",
    ButtonTag1: "Ethereum",
    ButtonTag2: "2.005 ETH",
    ButtonTag1Img: EthIcon,
    categories: ["DAO", "MetaVerse", "Utility", "Art", "Collectibles", "Defi"],
    TotalSupply: "10k",
    MintPrice: "5 ETH",
    CurrentPrice: "0.54 ETH",
    MintDate: "10h 10m",
    TwitterFollowers: "2k Followers",
    DiscordIcon: "5k Followers",
    TiktokFollowers: "1k followers",
    GraphData: [
      {
        name: "Page A",
        uv: 200,
        pv: 200,
        amt: 2400,
      },
      {
        name: "Page B",
        uv: 1000,
        pv: 130,
        amt: 2210,
      },
      {
        name: "Page C",
        uv: 2000,
        pv: 9800,
        amt: 2290,
      },
      {
        name: "Page D",
        uv: 2780,
        pv: 3908,
        amt: 2000,
      },
      {
        name: "Page E",
        uv: 1890,
        pv: 4800,
        amt: 2181,
      },
      {
        name: "Page F",
        uv: 23950,
        pv: 38050,
        amt: 2500,
      },
      {
        name: "Page G",
        uv: 3490,
        pv: 437800,
        amt: 6100,
      },
    ],
    TeamMembers: [
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "George",
        Doxxed: true
      },
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "William",
        Doxxed: false
      },
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Oscar",
        Doxxed: true
      }
    ],
    NotableFollowers: [
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Jennifer",
        NotableFollowerTwitter: "@jennifer"
      },
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Jacob",
        NotableFollowerTwitter: "@jacob"
      },
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Jaffer",
        NotableFollowerTwitter: "@jaffer"
      }
    ],
    Comments: [
      {
        ProfileAvatar: Avatar,
        ProfileName: "ehantari",
        Upvotes: " 1443",
        Time: "13 hr. ago",
        TwitterID: "@justinmiller",
        TwitterFollowers: "50k followers",
        Comment: "This is a Huge project in History of NFTs and Blockchain",
        Reply: [{
          ProfileAvatar: Avatar,
          ProfileName: "ehantari",
          Upvotes: " 1443",
          Time: "13 hr. ago",
          TwitterID: "@justinmiller",
          TwitterFollowers: "50k followers",
          Comment: "This is a Huge project in History of NFTs and Blockchain",
        }]
      }
    ],
  },
  {
    id: 2,
    MainImg: CryptoPunkImg,
    Heading: "Crypto Punk",
    trending: false,
    Rating: "568",
    text: "26 February 2022 - 10,000 unique collectible characters with proof of ownership stored on the Ethereum blockchain.",
    ButtonTag1: "Ethereum",
    ButtonTag2: "2.005 ETH",
    ButtonTag1Img: EthIcon,
    categories: ["DAO", "MetaVerse", "Utility", "Art", "Collectibles"],
    TotalSupply: "5k",
    MintPrice: "2 ETH",
    CurrentPrice: "0.54 ETH",
    MintDate: "8h 10m",
    TwitterFollowers: "2m Followers",
    DiscordIcon: "5m Followers",
    TiktokFollowers: "1m followers",
    GraphData: [
      {
        name: "Page A",
        uv: 700,
        pv: 700,
        amt: 2400,
      },
      {
        name: "Page B",
        uv: 3000,
        pv: 8398,
        amt: 2210,
      },
      {
        name: "Page C",
        uv: 6000,
        pv: 5800,
        amt: 2290,
      },
      {
        name: "Page D",
        uv: 7780,
        pv: 2908,
        amt: 2000,
      },
      {
        name: "Page E",
        uv: 3490,
        pv: 900,
        amt: 2181,
      },
      {
        name: "Page F",
        uv: 700,
        pv: 500,
        amt: 2500,
      },
      {
        name: "Page G",
        uv: 120,
        pv: 43500,
        amt: 2100,
      },
    ],
    TeamMembers: [
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Hasnain",
        Doxxed: true
      },
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Jose",
        Doxxed: true
      },
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Philip",
        Doxxed: false
      }
    ],
    NotableFollowers: [
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "David",
        NotableFollowerTwitter: "@david"
      },
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Ahsan",
        NotableFollowerTwitter: "@ahsan"
      },
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Jaffer",
        NotableFollowerTwitter: "@jaffer"
      }
    ],
    Comments: [
      {
        ProfileAvatar: Avatar,
        ProfileName: "daniyal",
        Upvotes: " 144",
        Time: "23 hr. ago",
        TwitterID: "@daniyal",
        TwitterFollowers: "30k followers",
        Comment: "This is a great project in History of NFTs and Blockchain",
        Reply: [{
          ProfileAvatar: Avatar,
          ProfileName: "dawood",
          Upvotes: " 143",
          Time: "21 hr. ago",
          TwitterID: "@dawood",
          TwitterFollowers: "10k followers",
          Comment: "This is a Big project in History of NFTs and Blockchain",
        }]
      },
      {
        ProfileAvatar: Avatar,
        ProfileName: "jose123",
        Upvotes: " 144",
        Time: "23 hr. ago",
        TwitterID: "@jose123",
        TwitterFollowers: "20k followers",
        Comment: "This is a great project in History of NFTs and Blockchain",
        Reply: [{
          ProfileAvatar: Avatar,
          ProfileName: "philip123",
          Upvotes: " 143",
          Time: "21 hr. ago",
          TwitterID: "@philip123",
          TwitterFollowers: "1k followers",
          Comment: "This is a Big project in History of NFTs and Blockchain",
        }]
      }
    ]
  },
  {
    id: 3,
    MainImg: CryptoPunkImg,
    trending: false,
    Heading: "Crypto Punk",
    Rating: "568",
    text: "26 February 2022 - 10,000 unique collectible characters with proof of ownership stored on the Ethereum blockchain.",
    ButtonTag1: "Ethereum",
    ButtonTag2: "2.005 ETH",
    ButtonTag1Img: EthIcon,
    categories: ["DAO", "MetaVerse"],
    TotalSupply: "2k",
    MintPrice: "2 ETH",
    CurrentPrice: "0.34 ETH",
    MintDate: "3h 10m",
    TwitterFollowers: "4k Followers",
    DiscordIcon: "5k Followers",
    TiktokFollowers: "1k followers",
    GraphData: [
      {
        name: "Page A",
        uv: 4340,
        pv: 450,
        amt: 2400,
      },
      {
        name: "Page B",
        uv: 300,
        pv: 34398,
        amt: 2210,
      },
      {
        name: "Page C",
        uv: 600,
        pv: 4800,
        amt: 2290,
      },
      {
        name: "Page D",
        uv: 1780,
        pv: 1908,
        amt: 2000,
      },
      {
        name: "Page E",
        uv: 1890,
        pv: 1800,
        amt: 2181,
      },
      {
        name: "Page F",
        uv: 23390,
        pv: 32800,
        amt: 2500,
      },
      {
        name: "Page G",
        uv: 34490,
        pv: 430120,
        amt: 2100,
      },
    ],
    TeamMembers: [
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "HazleWood",
        Doxxed: false
      },
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Joseph",
        Doxxed: true
      },
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Benjamin",
        Doxxed: true
      }
    ],
    NotableFollowers: [
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Dan",
        NotableFollowerTwitter: "@dan"
      },
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Phillip",
        NotableFollowerTwitter: "@Phillip"
      },
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Shalkon",
        NotableFollowerTwitter: "@shalkon"
      }
    ],
    Comments: [
      {
        ProfileAvatar: Avatar,
        ProfileName: "hasnain",
        Upvotes: " 144",
        Time: "23 hr. ago",
        TwitterID: "@hasnain",
        TwitterFollowers: "20k followers",
        Comment: "This is a great project in History of NFTs and Blockchain",
        Reply: [{
          ProfileAvatar: Avatar,
          ProfileName: "shalkon",
          Upvotes: " 143",
          Time: "21 hr. ago",
          TwitterID: "@shalkon",
          TwitterFollowers: "5k followers",
          Comment: "This is a Big project in History of NFTs and Blockchain",
        }]
      }
    ]
  },
  {
    id: 4,
    MainImg: CryptoPunkImg,
    trending: true,
    Heading: "Bitcoin",
    Rating: "568",
    text: "26 February 2022 - 10,000 unique collectible characters with proof of ownership stored on the Ethereum blockchain.",
    ButtonTag1: "Ethereum",
    ButtonTag2: "2.005 ETH",
    ButtonTag1Img: EthIcon,
    categories: ["DAO", "MetaVerse", "Utility"],
    TotalSupply: "1k",
    MintPrice: "4 ETH",
    CurrentPrice: "0.4 ETH",
    MintDate: "2h 10m",
    TwitterFollowers: "10k Followers",
    DiscordIcon: "50k Followers",
    TiktokFollowers: "10k followers",
    GraphData: [
      {
        name: "Page A",
        uv: 432000,
        pv: 243200,
        amt: 2400,
      },
      {
        name: "Page B",
        uv: 302300,
        pv: 1323498,
        amt: 2210,
      },
      {
        name: "Page C",
        uv: 203200,
        pv: 983200,
        amt: 2290,
      },
      {
        name: "Page D",
        uv: 2780,
        pv: 39058,
        amt: 2000,
      },
      {
        name: "Page E",
        uv: 18490,
        pv: 45800,
        amt: 2181,
      },
      {
        name: "Page F",
        uv: 23590,
        pv: 38400,
        amt: 2500,
      },
      {
        name: "Page G",
        uv: 35490,
        pv: 44300,
        amt: 2100,
      },
    ],
    TeamMembers: [
     
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "HazleWood",
        Doxxed: false
      },
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Joseph",
        Doxxed: true
      },
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Benjamin",
        Doxxed: true
      }
    ],
    NotableFollowers: [
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Danial",
        NotableFollowerTwitter: "@danial"
      },
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Darryl",
        NotableFollowerTwitter: "@Darryl"
      },
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Joseph",
        NotableFollowerTwitter: "@joseph"
      }
    ],
    Comments: [
      {
        ProfileAvatar: Avatar,
        ProfileName: "jose",
        Upvotes: " 144",
        Time: "23 hr. ago",
        TwitterID: "@jose",
        TwitterFollowers: "20k followers",
        Comment: "This is a great project in History of NFTs and Blockchain",
        Reply: [{
          ProfileAvatar: Avatar,
          ProfileName: "philip",
          Upvotes: " 143",
          Time: "21 hr. ago",
          TwitterID: "@philip",
          TwitterFollowers: "1k followers",
          Comment: "This is a Big project in History of NFTs and Blockchain",
        }]
      },
      {
        ProfileAvatar: Avatar,
        ProfileName: "jose123",
        Upvotes: " 144",
        Time: "23 hr. ago",
        TwitterID: "@jose123",
        TwitterFollowers: "20k followers",
        Comment: "This is a great project in History of NFTs and Blockchain",
        Reply: [{
          ProfileAvatar: Avatar,
          ProfileName: "philip123",
          Upvotes: " 143",
          Time: "21 hr. ago",
          TwitterID: "@philip123",
          TwitterFollowers: "1k followers",
          Comment: "This is a Big project in History of NFTs and Blockchain",
        }]
      }
    ],
  },
  {
    id: 5,
    MainImg: CryptoPunkImg,
    trending: false,
    Heading: "Bitcoin",
    Rating: "568",
    text: "26 February 2022 - 10,000 unique collectible characters with proof of ownership stored on the Ethereum blockchain.",
    ButtonTag1: "Ethereum",
    ButtonTag2: "2.005 ETH",
    ButtonTag1Img: EthIcon,
    categories: ["DAO", "MetaVerse", "Utility", "Art"],
    TotalSupply: "7k",
    MintPrice: "8 ETH",
    CurrentPrice: "0.84 ETH",
    MintDate: "12h 10m",
    TwitterFollowers: "4k Followers",
    DiscordIcon: "50k Followers",
    TiktokFollowers: "10k followers",
    GraphData: [
      {
        name: "Page A",
        uv: 40300,
        pv: 24030,
        amt: 2400,
      },
      {
        name: "Page B",
        uv: 30060,
        pv: 16398,
        amt: 2210,
      },
      {
        name: "Page C",
        uv: 20300,
        pv: 98400,
        amt: 2290,
      },
      {
        name: "Page D",
        uv: 25780,
        pv: 39408,
        amt: 2000,
      },
      {
        name: "Page E",
        uv: 18290,
        pv: 4800,
        amt: 2181,
      },
      {
        name: "Page F",
        uv: 234390,
        pv: 384400,
        amt: 2500,
      },
      {
        name: "Page G",
        uv: 3435490,
        pv: 433500,
        amt: 2100,
      },
    ],
    TeamMembers: [
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Jesse",
        Doxxed: true
      },
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Jacob",
        Doxxed: false
      },
      {
        TeamMemberImg: TeamMemberIcon,
        TeamMemberName: "Charlie",
        Doxxed: true
      }
    ],
    NotableFollowers: [
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Justin Miller",
        NotableFollowerTwitter: "@justinmiller"
      },
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Micheal",
        NotableFollowerTwitter: "@micheal"
      },
      {
        NotableFollowersImg: NotableFollowerImg,
        NotableFollowerName: "Jose",
        NotableFollowerTwitter: "@jose"
      }
    ],
    Comments: [
      {
        ProfileAvatar: Avatar,
        ProfileName: "jennifer",
        Upvotes: " 144",
        Time: "23 hr. ago",
        TwitterID: "@jennifer",
        TwitterFollowers: "2k followers",
        Comment: "This is a great project in History of NFTs and Blockchain",
        Reply: [{
          ProfileAvatar: Avatar,
          ProfileName: "chris",
          Upvotes: " 143",
          Time: "21 hr. ago",
          TwitterID: "@chris",
          TwitterFollowers: "1k followers",
          Comment: "This is a Big project in History of NFTs and Blockchain",
        }]
      }
    ]
  },
];
export default Data;
